export const UserType = {
  SHOP: 'Shop',
}

export const OrderStatus = {
  CANCEL: 0,
  CREATE: 1,
  PAYMENT_PENDING: 2,
  PAYMENT_COMPLETE: 3,
  ASSIGNED_SHOP: 4,
  ASSIGNED_DRIVER: 5,
  ON_PICKUP: 6,
  SHOP_CHECKIN: 7,
  IN_PROGRESS: 8,
  READY_FOR_DELIVERY: 9,
  SHOP_CHECKOUT: 10,
  ON_DELIVERY: 11,
  COMPLETE: 12,
}

export const AllowedOrderStatusTransitions = {
  [OrderStatus.CREATE]: [OrderStatus.PAYMENT_PENDING],
  [OrderStatus.PAYMENT_PENDING]: [OrderStatus.PAYMENT_COMPLETE],
  [OrderStatus.PAYMENT_COMPLETE]: [OrderStatus.ASSIGNED_SHOP],
  [OrderStatus.ASSIGNED_SHOP]: [OrderStatus.ASSIGNED_DRIVER],
  [OrderStatus.ASSIGNED_DRIVER]: [OrderStatus.ON_PICKUP],
  [OrderStatus.ON_PICKUP]: [OrderStatus.SHOP_CHECKIN],
  [OrderStatus.SHOP_CHECKIN]: [OrderStatus.IN_PROGRESS],
  [OrderStatus.IN_PROGRESS]: [OrderStatus.READY_FOR_DELIVERY],
  [OrderStatus.READY_FOR_DELIVERY]: [OrderStatus.SHOP_CHECKOUT],
  [OrderStatus.SHOP_CHECKOUT]: [OrderStatus.ON_DELIVERY],
  [OrderStatus.ON_DELIVERY]: [OrderStatus.COMPLETE],
}

export const DistributionType = {
  TIMESLOT: 'TimeSlot',
  AVAILABILITY: 'Availability',
  QUANTITY: 'Quantity',
}
